import {Address} from "../models/Address";

export const formatAddressLines = (a?: Address): string[] => {
    if (!a) {
        return [];
    }
    const l1 = [a.streetNumber, a.street].filter(Boolean).join(" ").trim();
    const l2 = [a.postalCode, a.city].filter(Boolean).join(", ").trim();
    const l3 = [a.country].filter(Boolean).join(" ").trim();
    return [l1, l2, l3].filter(Boolean);
};